import { toast } from 'react-toastify';
import successToastIcon from '../../assets/success_toast_icon.svg'
import CommonColorUtils from '../../utils/common_colors';

// Function to show the toast with a custom message
export const showSuccessToast = (toastMessage) => {
    toast.dismiss();
    toast.success( <div style={{
        display: 'flex',
        alignItems: 'center',
        color: CommonColorUtils.primarySuccessDarkGreen,
        backgroundColor:CommonColorUtils.primarySuccessLightGreen,
        padding: '10px',
        borderRadius: '8px'
    }}>
        <img src={successToastIcon} alt="Success Toast" style={{ marginRight: '10px' }} />
        <span>{toastMessage}</span>
    </div>, {
        position: "top-center",    // Position at the top center
        autoClose: 2000,           // Auto close after 2 seconds
        hideProgressBar: true,     // Hide progress bar
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,               // No default icon
        closeButton: false,
        style: {
            padding: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            width:'400px'
        }
    });
};

// Export CustomSuccessToast in case it needs to be used separately